<template>

    <div class="c-form_date">
        <form-label v-if="label">{{ label }}</form-label>
        <div
            class="c-form_date__inner">
            <datetime
                v-model="newValue"
                v-bind="$attrs"
                class="c-form_date__picker"
                :minute-step="5"
                :phrases="{ ok: 'Ok', cancel: 'Anuluj'}"
                :name="inputName"
                :input-class="getClasses"
                :min-datetime="compMinDatetime"
                :max-datetime="compMaxDatetime"
                @close="closePicker">
            </datetime>
        </div>
        <form-error-msg :msg="error || getError"></form-error-msg>
    </div>

</template>


<script>
import moment from 'moment'

moment.updateLocale(moment.locale(), {invalidDate: ""})

import {Settings} from 'luxon'

Settings.defaultLocale = 'pl'
import {Datetime} from 'vue-datetime'
import FormErrorMsg from './FormErrorMsg'
import FormLabel from './FormLabel'

export default {

    name: 'FormDate',

    inheritAttrs: false,

    $_veeValidate: {
        name() {
            return this.inputName
        },
        value() {
            return this.value
        },
    },

    props: {
        value: [String, Number, Object],
        label: String,
        name: String,
        minDatetime: String,
        maxDatetime: String,
        format: {
            type: String,
            default: 'YYYY-MM-DD HH:mm:ss'
        },
        disabled: Boolean,
        error: String,
    },

    data() {
        return {
            newValue: this.value
        }
    },

    computed: {
        inputName() {
            var tmp_name = this.$vnode.data.model.expression.split('.')
            var name = ''

            if (tmp_name.length > 1)
                name = tmp_name[tmp_name.length - 1]
            else
                name = tmp_name[0]

            return this.name || name
        },
        getError() {
            var err = this.errors.items.filter((error) => {
                return (error.field === this.inputName)
            })

            if (err.length)
                return err[0].msg
            else
                return null
        },
        getClasses() {
            return 'c-form_date__input' + (this.getError ? ' c-form_date__input--error' : '')
        },
        compMinDatetime() {
            if (!this.minDatetime)
                return null
            return moment(this.minDatetime).format()
        },
        compMaxDatetime() {
            if (!this.maxDatetime)
                return null
            return moment(this.maxDatetime).format()
        }
    },

    methods: {
        closePicker() {
            this.$emit('close')
            this.$nextTick(() => {
                this.$emit('blur')
            })
        }
    },

    watch: {
        value(value) {
            this.newValue = moment(value).format()
        },
        newValue(value) {
            this.$emit('input', moment(value).format(this.format))
        }
    },

    components: {
        FormErrorMsg,
        FormLabel,
        Datetime
    },

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_date {
    width: 100%;
    margin-bottom: 1rem;

    &__input {
        width: 100%;
        border-radius: 5px;
        border: 1px solid $c-border;
        font-size: 1rem;
        line-height: 2.4rem;
        height: 2.4rem;
        padding: 0 12px;
        color: $c-third;

        &--error {
            border-color: $c-red;
        }
    }
    &__inner {
        display: flex;
    }
    &__picker {
        width: 100%;

        .vdatetime-popup__header,
        .vdatetime-calendar__month__day--selected > span > span,
        .vdatetime-calendar__month__day--selected:hover > span > span {
            background: $c-primary;
        }
        .vdatetime-year-picker__item--selected,
        .vdatetime-time-picker__item--selected,
        .vdatetime-popup__actions__button {
            color: $c-third;
        }
    }
}

</style>

